/**
    path from send params to ym
    for webtest & prod need replace path from /offset/ to /gifts/
*/
export const PATH_FOR_YM_PARAMS = {
  OFFSET: '/offset/',
  GIFTS: '/gifts/',
};
